import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
    validateModel
} from '../../utils/helpers'
import moment from 'moment'
import {
    isFunction
} from 'util'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';
import {
    toast
} from 'react-toastify'
import history from '../../utils/history'
import diff from 'immutablediff'
import {
    Map
} from 'immutable'

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUD_REINICIAR_ESTADO
        })
    }
}

export function obtenerParametro(param) {
    const axios = createAxiosInstance()
    return (dispatch) => {
        axios.get(`${API_URL}/parametros?nombre=${param}`)
            .then((res) => {
                const fn1 = d => d({
                    type: types.SOLICITUD_POBLAR_PARAMETROS,
                    payload: {
                        parametro: param.toLowerCase(),
                        data: res.data
                    }
                })
                fn1(dispatch)
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
    }
}

export function ajustarCafeterias(to_add) {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUDES_AJUSTAR_LISTA_CAFETERIAS,
            payload: to_add
        })
    }
}

export function getSolicitud(id) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const fn1 = () => axios.get(`${API_URL}/solicitudes/${id}`)
        const fn2 = () => axios.post(`${API_URL}/list`, {
            modelo: 'TipoServicio',
            include: ['tipos_producto.users'],
            filters: [],
        })

        Promise.all([dispatch(obtenerParametro('CAFETERIAS')), fn1(), fn2()])
            .then(res => {
                const data = res[1].data
                let cafeteria = getState().solicitud.get('cafeterias').filter(x => x.get('nombre') === data.nombre_cafeteria)
                if (cafeteria.count() > 0) {
                    cafeteria = getState().solicitud.get('cafeterias').filter(x => x.get('nombre') === data.nombre_cafeteria).first().toJS()
                } else {
                    if (data.estado === 'CREADA') toast.warn('El nombre de la cafetería fue modificado, por favor, seleccione de nuevo la cafetería')
                    cafeteria = {
                        id: 0,
                        nombre: `*${data.nombre_cafeteria}`
                    }
                    dispatch(ajustarCafeterias(cafeteria))
                }

                dispatch({
                    type: types.SOLICITUD_CARGAR_SOLICITUD,
                    payload: {
                        id: data.id,
                        estado: data.estado,
                        solicitante: data.solicitante,
                        evento_actividad: data.evento_actividad,
                        cafeteria: JSON.stringify(cafeteria),
                        fecha: moment(data.fecha_hora).format('YYYY-MM-DD'),
                        hora: moment(data.fecha_hora).format('HH:mm'),
                        lugar: data.lugar,
                        motivo: data.motivo,
                        observaciones: data.observaciones,
                    }
                })
                const tipos_servicio = res[2].data
                data.detalles = data.detalles.map(x => {
                    x._enabled = true
                    x.tipos_servicio = tipos_servicio
                    x.tipos_producto = tipos_servicio.filter(y => y.nombre === x.tipo_servicio).length ? tipos_servicio.filter(y => y.nombre === x.tipo_servicio)[0].tipos_producto : []
                    return x
                })
                dispatch(tableActions.mswTable_mostrarDatos('solicitud', 'detalles', data.detalles, 1, data.detalles.length))
                data.distribuciones = data.distribuciones.map(x => {
                    x._enabled = true
                    return x
                })
                dispatch(tableActions.mswTable_mostrarDatos('solicitud', 'distribuciones', data.distribuciones, 1, data.distribuciones.length))
                dispatch({
                    type: types.SOLICITUD_RECALCULAR_TOTAL_SOLICITUD
                })
                dispatch({
                    type: types.SOLICITUD_CREAR_DISTRIBUCIONES_DETALLES_UNCHANGED
                })
                dispatch({
                    type: types.SOLICITUD_MARCAR_ACTUALIZADA,
                    payload: false
                })
            })
            .catch(err => {
                console.log(err)
                if (err && err.response && err.response.data) {
                    if (err.response.data.Exception === 'UNATHORIZED_RESOURCE') history.push(`${window.FOLDER}/solicitudes`);
                }
                displayMessages(dispatch, err)
            })
    }

}

export function aprobarDistribucion(aprobacion, estado) {
    const axios = createAxiosInstance()
    return (dispatch) => {
        aprobacion = aprobacion.set('estado', estado)
        axios.put(`${API_URL}/aprobaciones/${aprobacion.get('id')}`, aprobacion)
            .then(res => {
                displayMessages(dispatch, {
                    success: estado ? 'La solicitud ha sido aprobada exitosamente' : 'La solicitud ha sido rechazada exitosamente'
                })
                dispatch(getSolicitud(res.data.id))
            })
            .catch(err => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalCancel(show = false) {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUD_MOSTRAR_MODAL_CANCELAR_SOLICITUD,
            payload: {
                show
            }
        })
    }
}

export function cancelarSolicitud() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const id = getState().solicitud.getIn('modalCancel.data.id'.split('.'))
        axios.delete(`${API_URL}/solicitudes/${id}`)
            .then(res => {
                dispatch({
                    type: types.SOLICITUD_CANCELAR_SOLICITUD
                })
                dispatch(showHideModalCancel(false))
                displayMessages(dispatch, {
                    success: 'La solicitud ha sido cancelada exitosamente'
                })
            })
            .catch(err => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function eliminarDetalle() {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUD_ELIMINAR_DETALLE
        })

        dispatch({
            type: types.SOLICITUD_RECALCULAR_TOTAL_SOLICITUD
        })

        dispatch(marcarActualizada())
    }
}

export function eliminarRecurso() {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUD_ELIMINAR_RECURSO
        })

        dispatch(marcarActualizada())
    }
}

export function showHideModalAdicionarCencos(show = false, id = null) {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS,
            payload: {
                show,
                id
            }
        })
    }
}

export function actualizarDetalles() {
    return (dispatch, getState) => {
        const data = {
            _enabled: true,
            ...getState().solicitud.getIn(`modalAdicionarDetalle.data`.split('.')).toJS()
        }
        const valor_maximo = getState().solicitud.getIn(`modalAdicionarDetalle.data.valor_maximo`.split('.'))

        const modelState = validateModel(data, [{
                key: 'tipo_servicio',
                conditions: 'required'
            },
            {
                key: 'tipo_producto',
                conditions: 'required'
            },
            {
                key: 'menu',
                conditions: 'required'
            },
            {
                key: 'cantidad',
                conditions: 'required|number|min:1'
            },
            {
                key: 'valor_unitario',
                conditions: `required|number|min:0|max:${valor_maximo}`
            },
            {
                key: 'valor_fijo',
                conditions: 'required'
            },
            {
                key: 'subtotal',
                conditions: 'required|number'
            },
        ])

        if (modelState.length > 0) {
            modelState.forEach(x => {
                toast.warn(x.message)
            })
            return
        }

        if (data.id3n71f13r) {
            dispatch({
                type: types.SOLICITUD_ACTUALIZAR_DETALLES
            })
        } else {
            dispatch(tableActions.mwsTable_agregarRegistros('solicitud', 'detalles', data))
        }

        dispatch({
            type: types.SOLICITUD_RECALCULAR_TOTAL_SOLICITUD
        })
        dispatch(showHideModalAdicionarDetalles(false))
        dispatch(marcarActualizada())
    }
}

export function showHideModalAdicionarDetalles(show = false, id = null) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        if (!show) {
            dispatch({
                type: types.SOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES,
                payload: {
                    show,
                }
            })
            return
        }

        axios.get(`${API_URL}/tiposervicios`)
            .then((res) => {
                const tipos_servicio = res.data
                let tipos_producto = []
                if (id) {
                    const current_data = getState().solicitud.getIn(`detalles.data.${id}`.split('.'))
                    tipos_producto = current_data.getIn('tipos_producto'.split('.'))
                }

                dispatch({
                    type: types.SOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES,
                    payload: {
                        show,
                        lists: {
                            tipos_servicio,
                            tipos_producto
                        },
                        id
                    }
                })
                dispatch(calcularTotalDetalle())
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function actualizarDistribuciones() {
    return (dispatch, getState) => {
        const data = {
            _enabled: true,
            ...getState().solicitud.getIn(`modalAdicionarCenco.data`.split('.')).toJS()
        }
        const modelState = validateModel(data, [{
                key: 'cenco',
                conditions: 'required'
            },
            {
                key: 'porcentaje',
                conditions: 'required|number|min:0|max:100'
            },
        ])

        if (modelState.length > 0) {
            modelState.forEach(x => {
                toast.warn(x.message)
            })
            return
        }

        if (data.id3n71f13r) {
            dispatch({
                type: types.SOLICITUD_ACTUALIZAR_DISTRIBUCIONES
            })
        } else {
            dispatch(tableActions.mwsTable_agregarRegistros('solicitud', 'distribuciones', data))
        }

        dispatch({
            type: types.SOLICITUD_RECALCULAR_TOTAL_SOLICITUD
        })
        dispatch(showHideModalAdicionarCencos(false))
        dispatch(marcarActualizada())
    }
}

export function cargarOpcionesTipoServicio(selection) {
    return (dispatch, getState) => {
        const tipos_servicio = getState().solicitud.getIn('modalAdicionarDetalle.data.tipos_servicio'.split('.'))
        selection = tipos_servicio.filter(x => x.get('nombre') === selection).first()
        dispatch({
            type: types.SOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO,
            payload: {
                lists: {
                    tipos_producto: selection.get('tipos_producto')
                }
            }
        })
        dispatch(calcularTotalDetalle())
    }
}

export function cargarValoresTipoProducto(selection) {
    return (dispatch, getState) => {
        const tipos_producto = getState().solicitud.getIn('modalAdicionarDetalle.data.tipos_producto'.split('.'))
        selection = tipos_producto.filter(x => x.get('nombre') === selection).first()

        const lists = {
            descripcion: selection.get('descripcion'),
            valor_maximo: selection.get('valor_maximo'),
            valor_fijo: selection.get('valor_fijo'),
            preaprobacion: true,
        }
        if (lists.valor_fijo) lists.valor_unitario = lists.valor_maximo

        dispatch({
            type: types.SOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO,
            payload: {
                lists
            },
        })
        dispatch(calcularTotalDetalle())
    }
}

export function calcularTotalDetalle() {
    return (dispatch, getState) => {
        const valor_unitario = getState().solicitud.getIn('modalAdicionarDetalle.data.valor_unitario'.split('.')) || null
        const cantidad = getState().solicitud.getIn('modalAdicionarDetalle.data.cantidad'.split('.')) || null
        const tipo_producto = getState().solicitud.getIn('modalAdicionarDetalle.data.tipo_producto'.split('.'))
        const tipos_producto = getState().solicitud.getIn('modalAdicionarDetalle.data.tipos_producto'.split('.'))
        const selection = tipos_producto.filter(x => x.get('nombre') === tipo_producto).first()

        let subtotal = null
        if (valor_unitario && cantidad) {
            subtotal = valor_unitario * cantidad
        }
        dispatch({
            type: 'HYQ3_MODIFY_INPUT_VALUE',
            payload: {
                reducer: 'solicitud',
                path: 'modalAdicionarDetalle.data.subtotal',
                value: subtotal
            }
        })
        let preaprobacion = false
        if (selection) {
            preaprobacion = valor_unitario <= selection.get('valor_maximo')
        }
        dispatch({
            type: 'HYQ3_MODIFY_INPUT_VALUE',
            payload: {
                reducer: 'solicitud',
                path: 'modalAdicionarDetalle.data.preaprobacion',
                value: preaprobacion ? 'APROBADO' : 'NO APROBADO'
            }
        })
    }
}

export function guardarSolicitud() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('solicitud', true))
        let solicitud = getState().solicitud
        solicitud = solicitud.delete('modalAdicionarCenco')
        solicitud = solicitud.delete('modalAdicionarDetalle')
        solicitud = solicitud.delete('cafeterias')
        solicitud = solicitud.delete('saving')
        solicitud = solicitud.set('detalles', solicitud.getIn('detalles.data'.split('.')).valueSeq())
        solicitud = solicitud.set('distribuciones', solicitud.getIn('distribuciones.data'.split('.')).valueSeq())
        solicitud = solicitud.set('fecha_hora', `${solicitud.getIn('fecha'.split('.'))} ${solicitud.getIn('hora'.split('.'))}`)
        solicitud = solicitud.set('cafeteria', JSON.parse(solicitud.get('cafeteria')))

        axios.put(`${API_URL}/solicitudes/${solicitud.get('id')}`, solicitud)
            .then(res => {
                dispatch(setSavingState('solicitud', false))
                displayMessages(dispatch, {
                    success: 'Los registros han sido guardados exitosamente'
                })
                dispatch(getSolicitud(solicitud.get('id')))
            })
            .catch(err => {
                console.log(err)
                dispatch(setSavingState('solicitud', false))
                displayMessages(dispatch, err)
            })
    }
}

export function completarSolicitud() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('solicitud', true))
        let solicitud = getState().solicitud
        axios.get(`${API_URL}/solicitudes/completar/${solicitud.get('id')}`)
            .then(res => {
                dispatch(setSavingState('solicitud', false))
                displayMessages(dispatch, {
                    success: 'La solicitud ha sido marcada como completada'
                })
                dispatch(getSolicitud(solicitud.get('id')))
            })
            .catch(err => {
                console.log(err)
                dispatch(setSavingState('solicitud', false))
                displayMessages(dispatch, err)
            })
    }
}

export function marcarActualizada() {
    return (dispatch, getState) => {
        let updated = (diff(getState().solicitud.getIn('unchanged_distribuciones.data'.split('.')), getState().solicitud.getIn('distribuciones.data'.split('.')))).count() !== 0
        updated = updated || (diff(getState().solicitud.getIn('unchanged_detalles.data'.split('.')), getState().solicitud.getIn('detalles.data'.split('.')))).count() !== 0

        dispatch({
            type: types.SOLICITUD_MARCAR_ACTUALIZADA,
            payload: updated
        })
    }
}